export const TABS_SET_ACTIVID = 'TABS/SET_ACTIVID'